import API from "../../../services/api";

export const getUserProfile = async () => {
  return API.get(`/user_info/get_user_info?profile=true&basic_info=true`).then(
    response => response.data
  );
};

export const updateUserProfile = async payload => {
  return API.put("/user_info/update_user_info", payload).then(
    response => response.data
  );
};

export const getUserSpaces = async (id, only_active, marker, page_size) => {
  return API.get("spaces/get_spaces_of_user", {
    params: {
      user_id: id,
      only_active,
      marker,
      page_size
    }
  }).then(response => response.data);
};
